module.exports = __webpack_public_path__ + "img/storage_tank.c257be29.svg";